import React from 'react';

export default function Footer() {
  const handleUploadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const uploadButton = document.querySelector('[data-upload-trigger]') as HTMLElement;
    if (uploadButton) {
      uploadButton.click();
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Math&PhysicsVault by Mr. Hidayat Khan
            </h3>
            <p className="text-gray-400 mb-6 max-w-md">
              Your secure digital repository for mathematical and physics resources. Upload, organize, and access 
              your PDFs and videos with advanced file management capabilities.
            </p>
            <div className="flex space-x-4">
              <button className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-line"></i>
              </button>
              <button className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-line"></i>
              </button>
              <button className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-github-line"></i>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#upload-section" 
                  onClick={handleUploadClick}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Upload Files
                </a>
              </li>
              <li>
                <a href="#resources-section" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Browse Resources
                </a>
              </li>
              <li>
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Categories
                </button>
              </li>
              <li>
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Search
                </button>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li>
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Help Center
                </button>
              </li>
              <li>
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact Us
                </button>
              </li>
              <li>
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </button>
              </li>
              <li>
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Math&PhysicsVault by Mr. Hidayat Khan. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-4 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
